export default function IosFlower() {
  return (
    <div
      className="ion-icon-ios-flower"
      dangerouslySetInnerHTML={{
        __html: `<?xml version="1.0" encoding="utf-8"?>
<!-- Generator: Adobe Illustrator 16.2.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 width="512px" height="512px" viewBox="0 0 512 512" enable-background="new 0 0 512 512" xml:space="preserve">
<g>
	<path d="M395.057,228.247c-28.651,0-64.502,7.35-92.66,14.518c-0.98-3.443-2.321-6.734-4.001-9.817
		c24.97-14.84,55.487-34.98,75.733-55.224c39.547-39.547,52.023-68.458,40.44-80.042c-11.584-11.583-40.495,0.893-80.042,40.44
		c-20.225,20.225-40.343,50.698-55.178,75.654c-3.082-1.708-6.373-3.083-9.822-4.089c7.156-28.133,14.475-63.897,14.475-92.492
		C284.002,61.266,272.382,32,256,32s-28.002,29.266-28.002,85.194c0,28.595,7.319,64.359,14.475,92.492
		c-3.449,1.006-6.74,2.381-9.822,4.089c-14.835-24.956-34.953-55.43-55.176-75.653c-39.548-39.547-68.458-52.024-80.042-40.44
		c-11.584,11.583,0.894,40.494,40.44,80.041c20.246,20.244,50.762,40.384,75.732,55.224c-1.68,3.083-3.021,6.374-4.001,9.817
		c-28.158-7.168-64.008-14.518-92.659-14.518C61.016,228.247,32,239.618,32,256s29.016,28.252,84.944,28.252
		c28.697,0,64.613-7.371,92.792-14.551c1.01,3.414,2.384,6.671,4.083,9.724c-25.009,14.852-55.645,35.049-75.946,55.351
		c-39.547,39.548-52.023,68.459-40.44,80.043c11.584,11.584,40.495-0.895,80.042-40.441c20.323-20.323,40.542-51.001,55.398-76.024
		c3.053,1.671,6.31,3.01,9.718,3.995c-7.192,28.203-14.592,64.207-14.592,92.959c0,55.929,11.62,84.693,28.002,84.693
		s28.002-28.766,28.002-84.693c0-28.752-7.4-64.756-14.592-92.959c3.408-0.985,6.665-2.324,9.718-3.995
		c14.855,25.023,35.073,55.701,55.399,76.025c39.547,39.547,68.457,52.024,80.041,40.44s-0.894-40.495-40.439-80.043
		c-20.304-20.302-50.938-40.499-75.947-55.351c1.699-3.053,3.073-6.31,4.083-9.724c28.18,7.18,64.096,14.551,92.792,14.551
		c55.929,0,84.943-11.62,84.943-28.002S450.984,228.247,395.057,228.247z"/>
	<path d="M296.467,353.945c0,0,7.031,41.059,1.854,75.946c11.678,21.779,26.139,35.253,36.643,35.253
		c1.749,0,3.432-0.324,5.042-0.976c11.874-4.797,14.385-24.984,4.855-58.491C320.331,388.004,296.467,353.945,296.467,353.945z"/>
	<path d="M215.497,158.32c0,0-7.747-40.82-1.818-75.712c-13.292-23.51-26.139-35.255-36.644-35.255
		c-1.749,0-3.431,0.325-5.042,0.976c-11.868,4.795-14.497,23.211-4.87,58.441C188.375,122.75,215.497,158.32,215.497,158.32z"/>
	<path d="M158.306,296.717c0,0-41.308,6.119-75.949,1.852c-27.422,15.505-38.836,30.402-34.277,41.687
		c2.806,6.944,10.913,10.675,23.842,10.675c9.182,0,22.434-1.559,34.672-5.826C123.999,321.17,158.306,296.717,158.306,296.717z"/>
	<path d="M353.723,215.779c0,0,40.778-7.28,75.918-1.849c27.424-15.504,38.838-30.402,34.279-41.685
		c-2.806-6.945-10.914-10.675-23.844-10.675c-9.178,0-21.4,1.715-34.654,5.822C387.334,191.166,353.723,215.779,353.723,215.779z"/>
	<path d="M163.135,408.98c-8.42,30.34-5.956,48.938,5.244,53.69c1.674,0.711,3.437,1.066,5.275,1.066
		c11.107,0,24.698-13.124,39.528-39.015c-4.184-32.22,2.351-70.779,2.351-70.779S193.999,385.336,163.135,408.98z"/>
	<path d="M348.77,103.87c8.397-31.87,6.096-49.271-5.147-54.044c-1.674-0.71-3.438-1.066-5.274-1.066
		c-11.105,0-26.207,14.287-39.527,39.013c4.514,22.894-2.393,71.053-2.393,71.053S319.667,124.5,348.77,103.87z"/>
	<path d="M87.524,213.432c29.726-3.932,70.688,2.336,70.688,2.336S121,187.067,103.209,163.367
		C93,159.5,80.717,158.366,72.457,158.366c-12.267,0-20.042,3.573-22.881,10.261C44.572,180.419,59.546,198.612,87.524,213.432z"/>
	<path d="M424.477,299.066c-25.307,5.6-70.78-2.35-70.78-2.35s34.638,25.615,55.014,52.393c11.959,4.223,22.555,5.022,30.833,5.022
		c12.266,0,20.041-3.573,22.88-10.261C467.428,332.08,454.283,315.801,424.477,299.066z"/>
</g>
</svg>
`,
      }}
    />
  )
}
